"use client";

import { RootState } from "interfaces/generics.type";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";

const HeaderModalContainer = dynamic(() => import(/* webpackChunkName: "header-modal" */"./HeaderModalContainer"), {
  ssr: false,
});

function HeaderModalLoader() {
  const selectedId = useSelector((state: RootState) => state.modal.selectedId);

  const isLoading = useSelector((state: RootState) => state.loader.isLoading);
  if (selectedId || isLoading) {
    return (
      <HeaderModalContainer />
    );
  }
  return null;
}

export default HeaderModalLoader;
